import React, { Component } from 'react';
import Table from "../../../../../components/UI/Table/Table";
import {Button} from 'reactstrap';
import moment from 'moment';
import { DATE_FORMAT } from '../../../../../constants';

let that;
const tableColumns = [
    {
        Header: "Name",
        id: 'name',
        accessor: p => <p>{p.name}</p>
    },
    {
        Header: "Score",
        id: 'score',
        accessor: p => <p>{p.score}</p>
    },
    {
        Header: "Factors",
        id: 'factors',
        accessor: p => <p>{p.factors}</p>
    },
    {
        Header: "Rule",
        id: 'rule',
        accessor: p => <p>{p.rule}</p>
    },
    {
        Header: 'Created On',
        id: 'createdAt',
        accessor: p => <p>{moment(p.createdAt).format(DATE_FORMAT)}</p>
    },
    {
        Header: 'Actions',
        id: 'action',
        accessor: p => <Button color="primary" outline size="sm" onClick={() => that.handleEdit(p.id)}><i className="icon-edit" /></Button>
    }
]

class TableView extends Component {
    constructor(props){
        super(props);
        that = this;
    }

    handleEdit = (id) => {
        this.props.history.push(`./../edit/${id}`)
    }
    render() {
        return (
            <div className="">
                <Table
                    data={this.props.data}
                    columns={tableColumns}
                    defaultPageSize={5}
                    className="CreateCaseModalTable highlight"
                />
            </div>
        )
    }
}

export default TableView;
